import Video from '@intercom/embercom-composer/blocks/types/video';
import focusInput from '@intercom/embercom-composer/lib/focus-input';
import $ from 'jquery';
import Em from 'ember';
export default Em.Component.extend({
  classNames: ['ic-popup', 'ic-popup-left', 'ic-popup-short', 'is-light-theme', 'composer-video-inserter'],
  hasError: false,
  inputUrl: '',
  onInputUrlChanged: Em.observer({
    dependentKeys: ['inputUrl'],
    fn() {
      this.set('hasError', false);
    },
    sync: true
  }),
  didInsertElement() {
    this._super(...arguments);
    focusInput($('input:first', this.element));
  },
  actions: {
    insert() {
      let inputUrl = this.get('inputUrl');
      if (Em.isEmpty(inputUrl)) {
        return true;
      }
      let video = Video.create({
        config: this.get('config'),
        inputUrl
      });
      let options = {
        index: this.get('hoverCoordinates.insertionIndex'),
        selectNewBlock: false
      };
      if (video.get('isValid')) {
        this.insertBlock(video, options);
        return true;
      } else {
        this.set('hasError', true);
        return false;
      }
    }
  }
});